import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { I18nService } from '@personal-area/global/i18n';
import { UserFacade } from '@personal-area/global/users/services';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'pac-trader-sidebar',
  templateUrl: './trader-sidebar.component.html',
  styleUrls: ['./trader-sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [RouterLink, TranslateModule, RouterLinkActive, NgIf],
})
export class TraderSidebarComponent {
  private _i18nService = inject(I18nService);
  private _userFacade = inject(UserFacade);

  public get isPartner(): boolean {
    return this._userFacade.loggedUser.isPartner;
  }

  public get language(): string {
    return this._i18nService.languageA2;
  }
}
